/** Shared width for all right-hand side drawers (Add new app, Export, GX Go Assistant). */
export const DRAWER_WIDTH = '845px';
